/**
 * i18n — Español (es) ✅ COMPLETE
 */

import en from './en';

// Fetch base to extend
const es_base = {
  appTitle: 'Tarkov Money Maker 2',
  modeBadgePvp: 'PvP',
  modeBadgePve: 'PvE',
  modeBadgeSeason: 'Temporada 1',
  loading: 'Cargando',
  filterSearchLabel: 'Buscar',
  filterSearchPlaceholder: 'Nombre del ítem, Enter o clic…',
  filterSearchAddTerm: 'Añadir otro término…',
  filterSearchAdd: 'añadir',
  filterProfitLabel: 'Beneficio mín.',
  filterLevelLabel: 'Nivel del jugador',
  filterOffersLabel: 'Ofertas mín.',
  filterOffersDisabled: 'La API no proporciona el recuento de ofertas en este modo. Filtro desactivado.',
  traderEnable: 'activar',
  traderDisable: 'desactivar',
  intelNotBuilt: 'No construido',
  intelLevel1: 'Nivel 1',
  intelLevel2: 'Nivel 2',
  intelLevel3: '-30% tarifa flea',
  colItem: 'Ítem',
  colBuyTrader: 'Compra Trader',
  colSellTrader: 'Venta Trader',
  colAction: 'Acción',
  colBestProfit: '★ Mejor beneficio',
  colTraderFlea: 'Trader→Flea',
  colFleaTrader: 'Flea→Trader',
  colFlea: 'Flea',
  copyToast: '¡Copiado!',
  tooltipBuyPrices: 'Precios de compra del trader',
  tooltipSellPrices: 'Precios de venta',
  flea24h: 'Flea — 24h',
  fleaCur: 'Actual',
  fleaLow: 'Mín. 24h',
  fleaAvg: 'Med. 24h',
  fleaHigh: 'Máx. 24h',
  fleaOffers: 'ofertas',
  recFTS: 'Comprar Flea → Vender Trader',
  recBTF: 'Comprar Trader → Vender Flea',
  cardBuy: 'Compra',
  cardSell: 'Venta',
  cardOffers: 'ofertas',
  paginationOf: 'de',
  paginationPerPage: 'Por página:',
  paginationPage: 'Página',
  paginationTapSort: 'Toca para ordenar',
  noItems: 'No se encontraron ítems rentables. Baja el umbral o activa más traders.',
  chartTitle: 'Flea — instantánea 24h',
  chartNoData: 'Datos insuficientes',
  apiStatusTitle: 'Estado de sincronización',
  apiStatusOnline: 'tarkov.dev Online',
  apiStatusDegraded: 'tarkov.dev Degradado',
  apiStatusOffline: 'tarkov.dev Offline',
  apiStatusChecking: 'Verificando…',
  apiStatusGlobal: 'Estado global',
  apiStatusLastSync: 'Última sync',
  apiStatusItems: 'Ítems sincronizados',
  apiStatusItemsSub: 'total acumulado',
  apiStatusSource: 'Fuente API',
  apiStatusSourceSub: 'comprobación auto cada 30s',
  apiStatusCheckedAt: 'Comprobado',
  apiStatusModeStatus: 'Estado',
  apiStatusModeItems: 'Ítems',
  apiStatusModeLastSync: 'Última sync',
  apiStatusModeDuration: 'Duración',
  apiStatusNever: 'nunca',
  apiStatusJustNow: 'ahora mismo',
  apiStatusTimeAgoPrefix: 'hace',
  apiStatusMinutesAgo: 'min',
  apiStatusHoursAgo: 'h',
  apiStatusRest: 'REST',
  exportCSV: 'Exportar CSV',
  exportJSON: 'Exportar JSON',
  histFleaPrice: 'Precio Flea — últimas 24h',
  histOffers: 'Ofertas — últimas 24h',
  histLoading: 'Cargando historial…',
  histNoData: 'Aún no hay historial — los datos se acumulan tras cada sincronización.',
  histError: 'Servidor no disponible — el historial estará disponible cuando el backend esté en ejecución.',
};

export default es_base;
